// 申请单缓存数据

import { defineStore } from "pinia";

const useApplicationFormStore = defineStore("applicationForm", {
  state: () => ({
    updateData: {}, // 修改申请的数据
    updateSuccessFlag: false, // 修改申请单成功标志
  }),
});

export default useApplicationFormStore;
